import { schema } from 'normalizr'

const review = new schema.Entity('reviews')

export default review
